import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=0b2684f0&scoped=true&"
import script from "./UploadModal.vue?vue&type=script&lang=js&"
export * from "./UploadModal.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=0b2684f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2684f0",
  null
  
)

export default component.exports